import { Navigate } from '@sorare/routing';

import { ANY_SPORT_MARKET_WATCHLISTS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const RedirectToWatchlistsPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate to={generateSportContextPath(ANY_SPORT_MARKET_WATCHLISTS)} />
  );
};

export default RedirectToWatchlistsPage;
